import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { OrganizationFeatures } from "@vp/models";
import { FeatureService } from "@vp/shared/features";
import { AppSettingsResolverService } from "@vp/shared/utilities";
import { BehaviorSubject, map, Observable, of } from "rxjs";

@Component({
  selector: "vp-bottom-nav-shell",
  templateUrl: "./bottom-nav-shell.component.html",
  styleUrls: ["./bottom-nav-shell.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BottomNavShellComponent implements OnInit {
  private readonly featureService = inject(FeatureService);
  private readonly appSettingsResolverService = inject(AppSettingsResolverService);
  private readonly _isLoading$ = new BehaviorSubject<boolean>(false);

  appCopyright$: Observable<string> = of("");

  ngOnInit() {
    this.appCopyright$ = this.appSettingsResolverService.resolve().pipe(
      map(appSettings => {
        const copyright = appSettings.appCopyright;
        return copyright ? `© ${copyright}` : "";
      })
    );
  }

  isbottomNavigationtEnabled$ = this.featureService.featureEnabled$(
    OrganizationFeatures.bottomNavigation
  );
  isCopyrightEnabled$ = this.featureService.featureFlagEnabled$(
    OrganizationFeatures.bottomNavigation,
    "copyrightEnabled"
  );

  get isLoading$(): Observable<boolean> {
    return this._isLoading$.asObservable();
  }
}
